import React, { useCallback, useContext, useEffect } from 'react'
import { Alert, Container } from 'reactstrap'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Skeleton } from 'primereact/skeleton'
import { BI_AUT002Context } from './context'
import HeaderDefaultToPage from '../../components/Common/headerDefaultToPage'
import GridHeader from './Grid/GridHeader'
import GridBody from './Grid/GridBody'
import { fnGetValueByKey, fnGroupRecursiveData } from '../../helpers/functions'
import withRouter from '../../components/Common/withRouter'
import { AuthProtectedContext } from '../../Routes/AuthProtectedContext'
import useGetCsrfToken from '../../Hooks/useGetCsrfToken'

/**
 * Template automatizado
 * @description Esse template está mapeado para receber todos os dados de uma Procedure, e
 * se auto-rederizar.
 */

const BI_AUT002 = props => {
  console.log('🤖 %cTransação dinâmica [BI_AUT002]', 'color:green')
  const { transactionData } = useContext(AuthProtectedContext)
  const csrfToken = useGetCsrfToken();

  const { userFull, isModalPage, isIframePage } = useSelector(state => ({
    userFull: state.login.user,
    isModalPage: state.Layout.isModalPage,
    isIframePage: state.Layout.isIframePage
  }))

  const [isLoading, setisLoading] = useState(false)

  // Map Grid Component
  const [gridComponents, setgridComponents] = useState({
    HEAD: [],
    HEADER: [],
    BODY: [],
    FOOTER: []
  })

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [resultset1, setResultset1] = useState([])
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)

  useEffect(
    useCallback(() => {
      if (transactionData) {
        let recursiveTree = fnGroupRecursiveData(transactionData)
        // console.log("recursiveTree", recursiveTree);
        setgridComponents(state => ({
          ...state,
          HEAD: [Object.values(recursiveTree).find(e => e?.HEAD)?.HEAD],
          HEADER: [Object.values(recursiveTree).find(e => e?.HEADER)?.HEADER],
          BODY: [Object.values(recursiveTree).find(e => e?.BODY)?.BODY]
        }))
        setResultset1(transactionData)
      }
    }, [transactionData]),
    []
  )

  console.log('gridComponents: ', gridComponents)

  if (!transactionData)
    return (
      <div className={`page-content`}>
        <Alert color="danger">
          Esta é uma transação automática e configurável. Seu carregamento
          depende de uma rotina.
        </Alert>
      </div>
    )

  return (
    <React.Fragment>
      <BI_AUT002Context.Provider
        value={{
          isLoading,
          gridComponents,
          userFull,
          csrfToken
        }}
      >
        <div style={{ padding: (isModalPage || isIframePage) && '0px'}} className={`page-content`}>
          <Container fluid={true} className={`dataTable-custom-primary ${(isModalPage || isIframePage) && 'p-0'}`}>
            <HeaderDefaultToPage
              title={fnGetValueByKey(
                gridComponents.HEAD[0]?.Childrens,
                'TITULO_TRANSACAO'
              )}
            />
            {gridComponents.HEADER.length ? (
              <GridHeader />
            ) : (
              <Skeleton className="mb-3" width="100%" height="5rem"></Skeleton>
            )}
            {gridComponents.BODY.length ? (
              <GridBody />
            ) : (
              <Skeleton className="mb-3" width="100%" height="50vh"></Skeleton>
            )}
            {/* {gridComponents.FOOTER.length ? <code>GRID FOOTER não mapeado</code> : <Skeleton className="mb-3" width="100%" height="5rem"></Skeleton>} */}
          </Container>
        </div>
      </BI_AUT002Context.Provider>
    </React.Fragment>
  )
}

export default withRouter(BI_AUT002)
